import PropTypes from 'prop-types';
import styled from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
import themeColors from '../../assets/styles/themeColors';
import { ParagraphNormal } from '../Paragraph';
import { variables } from '../../assets/styles/variables';

const getButtonVariant = (variant) => {
  if (variant === 'primaryOutlined') {
    return `
      background: ${themeColors.colorButtonOutlined};
      color: ${themeColors.colorButtonOutlinedText};
      border: 1px solid ${themeColors.colorButtonOutlinedBorder};
      &:disabled {
        &:hover {
          color: ${themeColors.colorButtonOutlinedText};
          border: 1px solid ${themeColors.colorButtonOutlinedBorder};
        }
      }

 
      &:hover,
      &:focus,
      &:active {
        color: ${themeColors.colorButtonOutlinedText};
        border: 1px solid ${themeColors.colorButtonOutlinedBorder};
      }

      &:active {
        background-color: ${themeColors.colorButtonOutlined};
      }
    `;
  }
};

const Button = styled.button.attrs((props) => ({
  'data-cy': props['data-cy'] || 'default-button',
}))`
  display: flex;
  align-items: center;
  border-radius: ${variables.borderRadius.borderRadius};
  padding: 12px 24px;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: ${themeColors.colorButtonPrimary};
  width: ${({ width }) => width ?? 'auto'};
  justify-content: center;

  @media only screen and (max-width: 500px) {
    width: 100%;
  }

  &:active {
    background-color: ${themeColors.colorButtonPrimaryActive};
  }

  &:disabled {
    background-color: ${themeColors.colorButtonPrimaryInactive};
    cursor: not-allowed;
    pointer-events: all !important;
  }
  ${({ variant }) => getButtonVariant(variant)};
`;
const IconContainer = styled.div`
  margin-right: 10px;
`;

const ButtonPrimary = ({ title, onClick, Icon, variant, ...props }) => (
  <Button onClick={onClick} wight={600} variant={variant} {...props}>
    {!!Icon && <IconContainer>{Icon}</IconContainer>}
    <ParagraphNormal
      color={
        variant === 'primaryOutlined'
          ? themeColors.colorButtonOutlinedText
          : themeColors.colorWhite
      }
      weight={isMobileOnly ? 700 : 400}
    >
      {title}
    </ParagraphNormal>
  </Button>
);

ButtonPrimary.propTypes = {
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.string,
  Icon: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.string,
    PropTypes.shape({ render: PropTypes.func.isRequired }),
  ]),
};

ButtonPrimary.defaultProps = {
  onClick: Function.prototype,
};

export default ButtonPrimary;
